let translations = {},
    locale = 'en';

if ($('.builder-main').length) {
    translations = JSON.parse($('.builder-main').attr('data-translations'));
    locale = $('#alert-modal').attr('data-lang');
}

module.exports = {

    // Show Props content based on field type
    fieldSettings(tables = null, type) {

        switch (type) {
            case 'relationship' :
                return this.relationshipFieldContent(tables, type);
            case 'button' :
                return this.buttonFieldContent(tables, type);
            case 'signature' :
                return this.signatureFieldContent(tables, type);
            case 'phone' :
                return this.phoneFieldContent(type);
            case 'currency' :
                return this.currencyFieldContent(type);
            case 'number' :
                return this.numberFieldContent(type);
            case 'text' :
                return this.singleLineFieldContent(type);
            case 'image' :
                return this.imageFieldContent(type);
            case 'html' :
                return this.htmlFieldContent(type);
            case 'multiline' :
                return this.multiLineFieldContent(type);
            case 'date' :
                return this.dateFieldContent(type);
            case 'checkbox' :
                return this.booleanFieldContent(type);
            case 'select' :
                return this.selectOneFieldContent(type);
            case 'radio' :
                return this.selectRadioFieldContent(type);
            case 'multiselect':
                return this.selectMultiFieldContent(type);
            case 'multipleselect':
                return this.selectMultipleContent(type);
            case 'email' :
                return this.emailFieldContent(type);
            case 'website' :
                return this.websiteFieldContent(type);
            case 'autonumber' :
                return this.autoNumberFieldContent(type);
            case 'formula' :
                return this.formulaFieldContent(type);
            case 'alert' :
                return this.alertFieldContent(tables, type);
        }
    },

    // Single Line Field Content
    singleLineFieldContent(field) {

        let activeField = $('.activeField'),
            can_edit = true,
            field_name = $(activeField).attr('data-name');

        let default_fields = ['created_by', 'id', 'modified_by', 'company_id', 'created_at', 'updated_at', 'visibility'];

        if (default_fields.includes(field_name)) {
            can_edit = false;
            field = 'Default';
        }

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${translation.single_line_text}</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled"
                    ${!can_edit ? 'readonly' : ''}
                    >
            </div>
            <div class="pt-2 pb-2 ${!can_edit ? 'd-none' : ''}">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="unique"
                        id="isUniq">
                    <label class="form-check-label" for="isUniq">${translation.is_unique}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="capital"
                        id="capital">
                    <label class="form-check-label" for="capital">${translation.use_capital_letters}</label>
                </div>
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            ${can_edit ? `
                <div class="pt-2 pb-2">
                    <p> ${translation.field_type} : <span class="cu-font-sm">${translation.text}</span></p>
                </div>
            ` : ''}
        </div>
        `;

        return content;

    },

    buttonFieldContent(automations, field) {
        let content = '';

        content += `
                    <div class="col-12">
                        <div class="pt-2 pb-2">
                            <p> ${field} Field</p>
                        </div>
                        <div class="pt-2 pb-2">
                            <label>Button Label</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="label"
                                value="Untitled">
                        </div>
                        <div class="pt-2 pb-2">
                            <label>${translation.hint}</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="hint"
                                placeholder="${translation.enter_hint}">
                        </div>
                        <div class="pt-2 pb-2">
                            <label>Button Name</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="name"
                                value="Untitled">
                        </div>
                        <div class="pt-2 pb-2">
                            <label>Message</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="message"
                                placeholder="Enter Message">
                        </div>
                       
                        <div class="pt-2 pb-2 primary-col-holder">
                            <label>Trigger Automation</label>
                            <select
                                class="form-control propsChange"
                                data-field="automation-id">
                                ${automations}
                            </select>
                        </div>
                        
                        <div class="pt-2 pb-2">
                            <label>Button Color</label>
                             <div class="input-group-append btn-color" style="margin-left: 10px;" data-color="#0162A7">
                                <input type="text" class="form-control w-100" style="width:100px;" value="#0162A7" />
                                <span class="input-group-append">
                                    <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                </span>
                            </div>
                        </div>
                        
                        <div class="pt-2 pb-2">
                            <label>Button Text Color</label>
                             <div class="input-group-append btn-text-color" style="margin-left: 10px;" data-color="#0162A7">
                                <input type="text" class="form-control w-100" style="width:100px;" value="#0162A7" />
                                <span class="input-group-append">
                                    <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                </span>
                            </div>
                        </div>
                       
                        <div class="pt-2 pb-2">
                        <label>${translation.field_width_columns}</label>
                            <select class="form-control propsChange field-width"
                                data-field="width">
                                <option value="" disabled>${translation.select}</option> 
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </select>
                        </div>
                    
                    <div class="pt-2 pb-2 d-none">
                        <label>Button Height (Rows)</label>
                        <select class="form-control propsChange field-height"
                            data-field="height">
                            <option value="" disabled>${translation.select}</option> 
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select>
                    </div>
                    
                    <div class="pt-2 pb-2">
                        <p> ${translation.field_type} : <span class="cu-font-sm">${field}</span></p>
                    </div>
                    <div class="pt-2 pb-2 master-check">
                        <div class="form-group form-check on_show_relation">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                data-field="required"
                                checked
                                id="isprim" disabled>
                            <label class="form-check-label" for="primarymaster"> Is Primary Master</label>
                         </div>
                       </div>
                    </div>`;
        return content;
    },

    signatureFieldContent(automations, field) {
        let activeField = $('.activeField'),
            can_edit = true,
            field_name = $(activeField).attr('data-name');

        let default_fields = ['created_by', 'id', 'modified_by', 'assigned_to', 'company_id', 'created_at', 'updated_at', 'visibility'];

        if (default_fields.includes(field_name)) {
            can_edit = false;
            field = 'Default';
        }

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled"
                    ${!can_edit ? 'readonly' : ''}
                    >
            </div>
            <div class="pt-2 pb-2 ${!can_edit ? 'd-none' : ''}">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            ${can_edit ? `
                <div class="pt-2 pb-2">
                    <p> ${translation.field_type} : <span class="cu-font-sm">${translation.signature}</span></p>
                </div>
            ` : ''}
        </div>
        `;

        return content;
    },

    // Relationship Field Content
    relationshipFieldContent(tables, field) {

        let content = '';

        content += `
                    <div class="col-12">
                        <div class="pt-2 pb-2">
                            <p> ${translation.relationship_field} </p>
                        </div>
                        <div class="pt-2 pb-2">
                            <label>${translation.interface_name}</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="label"
                                value="Untitled">
                        </div>
                        <div class="pt-2 pb-2">
                            <label>${translation.hint}</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="hint"
                                placeholder="${translation.enter_hint}">
                        </div>
                        <div class="pt-2 pb-2">
                            <label>${translation.database_name}</label>
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="name"
                                value="Untitled">
                        </div>
                        <div class="pt-2 pb-1">
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input propsChange"
                                    data-field="required"
                                    id="isReq">
                                <label class="form-check-label" for="isReq">${translation.is_required}</label>
                            </div>
                        </div>
                        <div class="pb-2">
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input propsChange"
                                    data-field="scanner"
                                    id="isScanner">
                                <label class="form-check-label" for="isReq">${translation.enable_scanner}</label>
                            </div>
                        </div>
                        <div class="pt-2 pb-2">
                        <label>${translation.type}</label>
                        <select
                            class="form-control single-prop relation_type"
                            data-field="related-to" name="type">
                            <option value="lookup">Lookup</option>
                            <option value="masterdetail">MasterDetail</option>
                        </select>
                    </div>
                    <div class="pt-2 pb-2">
                        <label>${translation.related_to}</label>
                        <select
                            class="form-control propsChange showfields"
                            data-field="related-to">
                            <option disabled selected></option>
                            ${tables}
                        </select>
                        <label class="field_lbl">${translation.browse_columns}</label>
                        <ul class="related_Fields list-group">
                           
                        </ul>
                    </div>
                    <div class="pt-2 pb-2 primary-col-holder d-none">
                        <label>${translation.primary_column}</label>
                        <select
                            class="form-control propsChange select-primary-column"
                            data-field="primary-column">
                        </select>
                    </div>
                    
                    <div class="pt-2 pb-2 filter-col-holder d-none">
                        <label>${translation.group_by}</label>
                        <select
                            class="form-control select-filter-column"
                            data-field="filter-column">
                        </select>
                    </div>
                    
                    <div class="pt-2 pb-2 filter-col-holder d-none">
                        <label>${translation.default_filter}</label>
                        <select
                            class="form-control related-filter"
                            data-field="related-field-filter">
                        </select>
                    </div>
                    
                    <div class="pt-2 pb-2 relation-keys-holder">
                        <div class="text-center">
                            <label class="btn-link add-relation-key" style="cursor: pointer;">${translation.add_relation_keys}</a>
                        </div>
                        
                        <div class="relation-keys">
                            <div class="mappings-loader d-none text-center mt-3 mb-2">
                                <div>
                                    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         x="0px" y="0px"
                                         width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                        <path fill="#000"
                                              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                     <div class="pt-2 pb-2 mapping-holder d-none">
                        <div class="text-center">
                            <label class="btn-link add-mapping" style="cursor: pointer;">${translation.add_mapping_keys}</a>
                        </div>
                        
                        <div class="mapping-data">
                             <div class="mappings-loader d-none text-center mt-3 mb-2">
                                <div>
                                    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         x="0px" y="0px"
                                         width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                        <path fill="#000"
                                              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="pt-2 pb-2">
                    <label>${translation.field_width_columns}</label>
                        <select class="form-control propsChange field-width"
                            data-field="width">
                            <option value="" disabled>${translation.select}</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                        </select>
                    </div>
                    
                    <div class="pt-2 pb-2">
                    <label>${translation.field_height_rows}</label>
                        <select class="form-control propsChange field-height"
                            data-field="height">
                            <option value="" disabled>${translation.select}</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                        </select>
                    </div>
                    
                    <div class="pt-2 pb-2">
                        <p> ${translation.field_type} : <span class="cu-font-sm">${translation.relationship}</span></p>
                    </div>
                    <div class="pt-2 pb-2 master-check">
                        <div class="form-group form-check on_show_relation">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                data-field="required"
                                checked
                                id="isprim" disabled>
                            <label class="form-check-label" for="primarymaster"> Is Primary Master</label>
                         </div>
                       </div>
                    </div>`;
        return content;
    },

    // Phone Field Content
    phoneFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${translation.phone_field}</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="unique"
                        id="isUniq">
                    <label class="form-check-label" for="isUniq">${translation.is_unique}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.phone}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Currency Field Content
    currencyFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${translation.field_type_currency}</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
               <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
<!--            <div class="pt-2 pb-2">-->
<!--                <div class="form-group form-check">-->
<!--                    <input-->
<!--                        type="checkbox"-->
<!--                        class="form-check-input propsField"-->
<!--                        data-field="required"-->
<!--                        id="isReq">-->
<!--                    <label class="form-check-label" for="isReq">${translation.is_required}</label>-->
<!--                </div>-->
<!--            </div>-->
            
            <div class="pt-0 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="nonzero"
                        id="nonzero">
                    <label class="form-check-label" for="nonzero">${translation.cannot_be_0}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.currency}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Number Field Content
    numberFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
               <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
<!--            <div class="pt-2 pb-2">-->
<!--                <div class="form-group form-check">-->
<!--                    <input-->
<!--                        type="checkbox"-->
<!--                        class="form-check-input propsChange"-->
<!--                        data-field="required"-->
<!--                        id="isReq">-->
<!--                    <label class="form-check-label" for="isReq">${translation.is_required}</label>-->
<!--                </div>-->
<!--            </div>-->
            <div class="pt-0 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="nonzero"
                        id="nonzero">
                    <label class="form-check-label" for="nonzero">${translation.cannot_be_0}</label>
                </div>
            </div>
            <div class="pt-2 pb-2">
                <label>Type</label>
                <select class="form-control propsChange number-typ" name="type" data-field="number-type">
                    <option value="decimal">${translation.decimal}</option>
                    <option value="number">${translation.number}</option>
                </select>
           </div>
           
           <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
           
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.number}</span></p>
                <p>
                    ${translation.maximum_9_digits}
                </p>
            </div>
        </div>
        `;

        return content;

    },

    // Formula Field Content
    formulaFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            
            <div class="pt-2 pb-2">
               <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            
            <div class="pt-0 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="nonzero"
                        id="nonzero">
                    <label class="form-check-label" for="nonzero">${translation.cannot_be_0}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
                <label>Formula <a href="#" id="edit-formula">(${translation.edit})</a></label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="formula"
                    placeholder="Formula" readonly>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
          
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${field}</span> <a href="#" class="edit-formula-order">(${translation.order})</a></p>
            </div>
        </div>
        `;

        return content;

    },

    htmlFieldContent(field) {

        let activeField = $('.activeField'),
            can_edit = true,
            field_name = $(activeField).attr('data-name');

        let default_fields = ['created_by', 'id', 'modified_by', 'assigned_to', 'company_id', 'created_at', 'updated_at', 'visibility'];

        if (default_fields.includes(field_name)) {
            can_edit = false;
            field = 'Default';
        }

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled"
                    ${!can_edit ? 'readonly' : ''}
                    >
            </div>
            <div class="pt-2 pb-2 ${!can_edit ? 'd-none' : ''}">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            ${can_edit ? `
                <div class="pt-2 pb-2">
                    <p> ${translation.field_type} : <span class="cu-font-sm">${field}</span></p>
                </div>
            ` : ''}
        </div>
        `;

        return content;

    },

    imageFieldContent(field) {

        let activeField = $('.activeField'),
            can_edit = true,
            field_name = $(activeField).attr('data-name');

        let default_fields = ['created_by', 'id', 'modified_by', 'assigned_to', 'company_id', 'created_at', 'updated_at', 'visibility'];

        if (default_fields.includes(field_name)) {
            can_edit = false;
            field = 'Default';
        }

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled"
                    ${!can_edit ? 'readonly' : ''}
                    >
            </div>
            <div class="pt-2 pb-2 ${!can_edit ? 'd-none' : ''}">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            ${can_edit ? `
                <div class="pt-2 pb-2">
                    <p> ${translation.field_type} : <span class="cu-font-sm">${translation.image}</span></p>
                </div>
            ` : ''}
        </div>
        `;

        return content;

    },

    // Multi Line Field Content
    multiLineFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="capital"
                        id="capital">
                    <label class="form-check-label" for="capital">${translation.use_capital_letters}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.multiline}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Date and Time Field Content
    dateFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.type}</label>
                <select
                    class="form-control propsChange date-time-type"
                    data-field="date-time" name="type">
                    <option value="date">${translation.date}</option>
                    <option value="datetime">${translation.datetime}</option>
                    <option value="time">${translation.time}</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.date}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Checkbox Field Content
    booleanFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> Boolean Field </p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
               <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="default"
                        id="isDefYes">
                    <label class="form-check-label" for="isDefYes">Checked by default</label>
                </div>
                
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm"> ${translation.boolean} </span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Select One Option Field Content
    selectOneFieldContent(field) {

        let content = '';

        content += `
                    <div class="col-12">
                        <div class="pt-2 pb-2">
                            <p> ${translation.single_select} </p>
                        </div>
                        <div class="pt-2 pb-2">
                            <label>${translation.interface_name}</label> 
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="label"
                                value="Untitled">
                        </div>
                        <div class="pt-2 pb-2">
                           <label>${translation.hint}</label> 
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="hint"
                                placeholder="${translation.enter_hint}">
                        </div>
                        <div class="pt-2 pb-2">
                            <label>${translation.database_name}</label> 
                            <input
                                type="text"
                                class="form-control propsField"
                                data-field="name"
                                value="Untitled"
                                placeholder="Untitled">
                        </div>
                        <div class="pt-2 pb-2">
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input propsChange"
                                    data-field="required"
                                    id="isReq">
                                <label class="form-check-label" for="isReq">${translation.is_required}</label>
                            </div>
                        </div>
                        <div class="pt-2 pb-2 mb-1 options-blocks selectOptions">
                            <p class="mb-1">${translation.options}</p>
            
                            <div class="input-group mb-1 option-block">
            
                                <div class="input-group-prepend">
                                    <span class="input-group-text orderSelectopt">
                                        <i class="fas fa-arrows-alt"></i>
                                    </span>
                                </div>
            
                                <input
                                    type="text"
                                    class="form-control propsField selectField"
                                    data-field="values"
                                    value="${translation.option_1}">
            
                                <div class="input-group-append">
                                    <span class="input-group-text deleteSelectopt">
                                        <i class="fas fa-times"></i>
                                    </span>
                                </div>
                                
                                <div class="input-group-append change_option" style="margin-left: 10px;" data-color="#0162A7">
                                    <input type="text" class="form-control input-lg" style="width:100px;" value="#0162A7" />
                                    <span class="input-group-append">
                                        <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                    </span>
                                </div>
                            </div>
            
                            <div class="input-group mb-1 option-block">
                                <div class="input-group-prepend">
                                    <span class="input-group-text orderSelectopt">
                                        <i class="fas fa-arrows-alt"></i>
                                    </span>
                                </div>
            
                                <input
                                    type="text"
                                    class="form-control propsField selectField"
                                    data-field="values"
                                    value="${translation.option_2}">
            
                                <div class="input-group-append">
                                    <span class="input-group-text deleteSelectopt">
                                        <i class="fas fa-times"></i>
                                    </span>
                                </div>
                                
                                <div class="input-group-append change_option" style="margin-left: 10px;" data-color="#0162A7">
                                    <input type="text" class="form-control input-lg" style="width:100px;" value="#0162A7" />
                                    <span class="input-group-append">
                                        <span class="input-group-text colorpicker-input-addon"><i></i></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="pt-1 pb-1">
                            <div class="addoptions">
                                <input
                                    type="text"
                                    class="form-control option-control"
                                    placeholder="${translation.add_new_option}">
                                <input
                                    type="submit"
                                    class="option-btn btn btn-sm btn-success"
                                    value="${translation.add}">
                            </div>
                        </div>
                        
                        <div class="pt-2 pb-2">
                            <select class="form-control single-prop" data-field="single-selection" name="type">
                                <option value="select">${translation.dropdown_menu}</option>
                                <option value="radio">${translation.radio_button}</option>
                            </select>
                       </div>
                       
                       <div class="pt-2 pb-2">
                        <label>${translation.field_width_columns}</label>
                            <select class="form-control propsChange field-width"
                                data-field="width">
                                <option value="" disabled>${translation.select}</option> 
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </select>
                        </div>
                        
                        <div class="pt-2 pb-2">
                        <label>${translation.field_height_rows}</label>
                            <select class="form-control propsChange field-height"
                                data-field="height">
                                <option value="" disabled>${translation.select}</option> 
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                            </select>
                        </div>
                       
                        <div class="pt-2 pb-2 mt-2">
                            <p> ${translation.field_type} : <span class="cu-font-sm">${translation.select_picklist}</span></p>
                        </div>
                    </div>`;
        return content;

    },

    selectRadioFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> Picklist Field </p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2 mb-1 options-blocks selectradio">
                <p class="mb-1">${translation.options}</p>

                <div class="input-group mb-1 option-block">

                    <div class="input-group-prepend">
                        <span class="input-group-text orderSelectopt">
                            <i class="fas fa-arrows-alt"></i>
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control propsField selectField"
                        data-field="values"
                        value="Yes"
                        >
                        <div class="input-group-append">
                        <span class="input-group-text deleteSelectopt">
                            <i class="fas fa-times"></i>
                        </span>
                    </div>
                    
                    <div class="input-group-append change_option" style="margin-left: 10px;" data-color="#0162A7">
                        <input type="text" class="form-control input-lg" style="width:100px;" value="#0162A7" />
                        <span class="input-group-append">
                            <span class="input-group-text colorpicker-input-addon"><i></i></span>
                        </span>
                    </div>

                </div>

                <div class="input-group mb-1 option-block">

                    <div class="input-group-prepend">
                        <span class="input-group-text orderSelectopt">
                            <i class="fas fa-arrows-alt"></i>
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control propsField selectField"
                        data-field="values"
                        value="No">
                        <div class="input-group-append">
                        <span class="input-group-text deleteSelectopt">
                            <i class="fas fa-times"></i>
                        </span>
                    </div>
                    
                    <div class="input-group-append change_option" style="margin-left: 10px;" data-color="#0162A7">
                        <input type="text" class="form-control input-lg" style="width:100px;" value="#0162A7" />
                        <span class="input-group-append">
                            <span class="input-group-text colorpicker-input-addon"><i></i></span>
                        </span>
                    </div>
                </div>


            </div>
            <div class="pt-1 pb-1">
            <div class="addoptions">
                <input
                    type="text"
                    class="form-control option-control"
                    placeholder="${translation.add_new_option}">
                <input
                    type="submit"
                    class="option-btn btn btn-sm btn-success"
                    value="Add">
            </div>
          </div>
            <div class="pt-2 pb-2">
                <select class="form-control single-prop" data-field="single-selection" name="type">
                    <option value="select">${translation.dropdown_menu}</option>
                    <option value="radio" selected>${translation.radio_button}</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2 mt-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.select_picklist}</span></p>
            </div>
        </div>
        `;

        return content;
    },

    selectMultipleContent(field) {
        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> MultiPicklist </p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
               <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2 mb-1 options-blocks multiselectOptions">
                <p class="mb-1">${translation.options}</p>

                <div class="input-group mb-1 option-block">

                    <div class="input-group-prepend">
                        <span class="input-group-text orderSelectopt">
                            <i class="fas fa-arrows-alt"></i>
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control propsField"
                        data-field="values"
                        value="${translation.option_1}"
                        >

                    <div class="input-group-append">
                        <span class="input-group-text deleteSelectopt">
                            <i class="fas fa-times"></i>
                        </span>
                    </div>

                </div>

                <div class="input-group mb-1 option-block">

                    <div class="input-group-prepend">
                        <span class="input-group-text orderSelectopt">
                            <i class="fas fa-arrows-alt"></i>
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control propsField"
                        data-field="values"
                        value="${translation.option_2}">

                    <div class="input-group-append">
                        <span class="input-group-text deleteSelectopt">
                            <i class="fas fa-times"></i>
                        </span>
                    </div>

                </div>


            </div>
            <div class="pt-1 pb-1">
                <div class="addoptions">
                    <input
                        type="text"
                        class="form-control option-control"
                        placeholder="${translation.add_new_option}">
                    <input
                        type="submit"
                        class="option-btn btn btn-sm btn-success"
                        value="${translation.add}">
                </div>
            </div>
            <div class="pt-2 pb-2">
                <select class="form-control single-prop" data-field="multi-selection" name="type">
                    <option value="multipleselect" selected>${translation.dropdown_menu}</option>
                    <option value="multiselect">${translation.checkbox}</option>
                </select>
           </div>
           
           <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
           
            <div class="pt-2 pb-2 mt-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.multiselect}</span></p>
            </div>
        </div>
        `;

        return content;
    },
    // Select Multi Options Field Content
    selectMultiFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> MultiPicklist </p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
            </div>
            <div class="pt-2 pb-2 mb-1 options-blocks multipleOptions">
                <p class="mb-1">${translation.options}</p>

                <div class="input-group mb-1 option-block">

                    <div class="input-group-prepend">
                        <span class="input-group-text orderSelectopt">
                            <i class="fas fa-arrows-alt"></i>
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control propsField selectField"
                        data-field="values"
                        value="${translation.option_1}"
                        >

                    <div class="input-group-append">
                        <span class="input-group-text deleteSelectopt">
                            <i class="fas fa-times"></i>
                        </span>
                    </div>

                </div>

                <div class="input-group mb-1 option-block">

                    <div class="input-group-prepend">
                        <span class="input-group-text orderSelectopt">
                            <i class="fas fa-arrows-alt"></i>
                        </span>
                    </div>

                    <input
                        type="text"
                        class="form-control propsField selectField"
                        data-field="values"
                        value="${translation.option_2}">

                    <div class="input-group-append">
                        <span class="input-group-text deleteSelectopt">
                            <i class="fas fa-times"></i>
                        </span>
                    </div>

                </div>
            </div>
            
            <div class="pt-1 pb-1">
                <div class="addoptions">
                    <input
                        type="text"
                        class="form-control option-control"
                        placeholder="${translation.add_new_option}">
                    <input
                        type="submit"
                        class="option-btn btn btn-sm btn-success"
                        value="${translation.add}">
                </div>
            </div>
            <div class="pt-2 pb-2">
                <select class="form-control single-prop" data-field="multi-selection" name="type">
                    <option value="multipleselect">${translation.dropdown_menu}</option>
                    <option value="multiselect" selected>${translation.checkbox}</option>
                </select>
           </div>
           
           <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
           
            <div class="pt-2 pb-2 mt-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.multiselect}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Email Field Content
    emailFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="unique"
                        id="isUniq">
                    <label class="form-check-label" for="isUniq">${translation.is_unique}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="capital"
                        id="capital">
                    <label class="form-check-label" for="capital">${translation.use_capital_letters}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.email}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Website Field Content
    websiteFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="required"
                        id="isReq">
                    <label class="form-check-label" for="isReq">${translation.is_required}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="unique"
                        id="isUniq">
                    <label class="form-check-label" for="isUniq">${translation.is_unique}</label>
                </div>
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="capital"
                        id="capital">
                    <label class="form-check-label" for="capital">${translation.use_capital_letters}</label>
                </div>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.website}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    // Auto Number Field Content
    autoNumberFieldContent(field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
                <a href="#" class="edit-no-series"> ${translation.no_series} </a>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value="Untitled"
                    placeholder="Untitled">
            </div>
            
            <div class="pt-2 pb-2 auto-type-container">
                <label>Type</label>
                <select class="form-control propsChange auto-field-type"
                    data-field="auto_field_type">
                    <option value="alpha">${translation.alphabet}</option>
                    <option value="numeric">${translation.numerical}</option>
                </select>
            </div>

            <div class="pt-2 pb-2 pattern-container">
                <label>Pattern</label>
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="pattern"
                    placeholder="N001"
                    pattern="[a-zA-z0-9]+">
                <small>${translation.pattern_0_3}</small>
                
<!--                <div class="form-group form-check auto-pattern-holder">-->
<!--                    <input-->
<!--                        type="checkbox"-->
<!--                        class="form-check-input propsChange"-->
<!--                        data-field="enable_pattern">-->
<!--                    <label class="form-check-label">Enable Pattern</label>-->
<!--                </div>-->
            </div>
            
            <div class="pt-2 pb-2">
                <div class="form-group form-check">
                    <input
                        type="checkbox"
                        class="form-check-input propsChange"
                        data-field="view_only">
                    <label class="form-check-label">${translation.view_only}</label>
                </div>
            </div>

            <div class="form-group form-check">
                <input
                    type="checkbox"
                    class="form-check-input propsChange"
                    data-field="unique"
                    id="isUniq">
                <label class="form-check-label" for="isUniq">${translation.is_unique}</label>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>

            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.autonumber}</span></p>
            </div>
        </div>
        `;

        return content;
    },

    // Auto Number Field Content
    alertFieldContent(fields, field) {

        let content = '';

        content += `
        <div class="col-12">
            <div class="pt-2 pb-2">
                <p> ${field} Field</p>
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.interface_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="label"
                    value="Untitled">
            </div>
            <div class="pt-2 pb-2">
            <label>${translation.hint}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="hint"
                    placeholder="${translation.enter_hint}">
            </div>
            <div class="pt-2 pb-2">
                <label>${translation.database_name}</label> 
                <input
                    type="text"
                    class="form-control propsField"
                    data-field="name"
                    value=""
                    placeholder="Untitled">
            </div>

            <div class="pt-2 pb-2">
            <label>${translation.alert_type}</label>
                <select multiple
                    class="form-control propsField alert-type selectpicker"
                    data-field="alert_type">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="notification">${translations.notification}</option>
                    <option value="sms">${translations.sms}</option>
                    <option value="email">${translations.email}</option>
                    <option value="message">${translations.message}</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.event_field}</label>
                <select 
                    class="form-control propsField alert-field"
                    data-field="alert_field">
                    <option disabled selected value="">${translation.select_field}</option>
                    ${fields}
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.option}</label>
                <select class="form-control propsField alert-option selectpicker"
                    data-field="alert_type" multiple>
                    <option value="" disabled>${translation.select}</option> 
                    <option value="at_event">${translations.at_event}</option>
                    <option value="minutes_before">${translations.minutes_before}</option>
                    <option value="hours_before">${translations.hours_before}</option>
                    <option value="days_before">${translations.days_before}</option>
                    <option value="minutes_after">${translations.minutes_after}</option>
                    <option value="hours_after">${translations.hours_after}</option>
                    <option value="days_after">${translations.days_after}</option>
                    <option value="on_date">${translations.on_date}</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2 default-value-holder d-none">
                <label>Default Value</label>
                <input
                    type="text"
                    class="form-control propsField custom-value-date"
                    data-field="default_value"
                    value=""
                    placeholder="">
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_width_columns}</label>
                <select class="form-control propsChange field-width"
                    data-field="width">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                </select>
            </div>
            
            <div class="pt-2 pb-2">
            <label>${translation.field_height_rows}</label>
                <select class="form-control propsChange field-height"
                    data-field="height">
                    <option value="" disabled>${translation.select}</option> 
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                </select>
            </div>

            <div class="pt-2 pb-2">
                <p> ${translation.field_type} : <span class="cu-font-sm">${translation.alert}</span></p>
            </div>
        </div>
        `;

        return content;

    },

    /**
     * Show field in Section
     */
    getFieldData(field, order = 1, label = "Untitled", name, options, id) {

        switch (field) {

            case 'relationship' :
                return this.fieldContent('relationship', field, order);
            case 'text' :
                return this.fieldContent('text', field, order);
            case 'image' :
                return this.fieldContent('text', field, order);
            case 'button' :
                return this.fieldContent('button', field, order);
            case 'signature' :
                return this.fieldContent('signature', field, order);
            case 'html' :
                return this.fieldContent('text', field, order);
            case 'phone' :
                return this.fieldContent('text', field, order);
            case 'email' :
                return this.fieldContent('email', field, order);
            case 'currency' :
                return this.fieldContent('number', field, order);
            case 'number' :
                return this.fieldContent('decimal', field, order);
            case 'date' :
                return this.fieldContent('date', field, order);
            case 'multiline' :
                return this.fieldContent('textarea', field, order);
            case 'checkbox' :
                return this.fieldContent('checkbox', field, order);
            case 'select' :
                return this.fieldContent('select', field, order, label, name, options, id);
            case 'radio' :
                return this.fieldContent('radio', field, order, label, name, options, id);
            case 'multiselect' :
                return this.fieldContent('checkbox', field, order, label, name, options, id);
            case 'multipleselect' :
                return this.fieldContent('select', field, order, label, name, options, id);
            case 'website' :
                return this.fieldContent('url', field, order);
            case 'autonumber' :
                return this.fieldContent('text', field, order);
            case 'formula' :
                return this.fieldContent('formula', field, order);
            case 'alert' :
                return this.fieldContent('alert', field, order);
        }

    },

    // Field Section Content
    fieldContent(type, field, order, label = "Untitled", name = "untitled", options, id) {

        console.log(type);
        let content = '';
        id = (typeof id != 'undefined') ? id : '';
        let values = (typeof options != 'undefined') ? options.join(',') : '';
        content += `<div class="section-field-container drag-field">
                        <div class="row">`;

        switch (field) {
            case 'button':
                content += `<div class="col-9">
                                <label>${label}</label>
                                <button
                                    data-field="${field}"
                                    data-type="${type}"
                                    data-label="${label}"
                                    data-hint="${label}"
                                    data-name="${name}"
                                    data-order="${order}"
                                    data-values="${values}"
                                    data-automation-id=""
                                    data-message=""
                                    data-hidden="0"
                                    data-required="0"
                                    data-id="${id}"
                                    class="btn btn-primary apply-btn-color d-block is-button propsControl activeField fieldItem"
                                >Untitled</button>
                            </div>`;
                break;
            case 'select':
                content += `<div class="col-9">
                                <label>${label}</label>
                                <select
                                    data-field="${field}"
                                    data-type="${type}"
                                    data-label="${label}"
                                    data-hint="${label}"
                                    data-name="${name}"
                                    data-order="${order}"
                                    data-values="${values}"
                                    data-hidden="0"
                                    data-required="0"
                                    data-id="${id}"
                                    class="form-control propsControl activeField fieldItem"
                                    disabled>
                                <option selected disabled> -- Select an option -- </option>
                                </select>
                            </div>`;
                break;
            case 'multipleselect':
                content += `<div class="col-9">
                                <label>${label}</label>
                                <select
                                    data-field="${field}"
                                    data-type="multipleselect"
                                    data-label="${label}"
                                    data-name="${name}"
                                    data-hint="${label}"
                                    data-order="${order}"
                                    data-values="${values}"
                                    data-hidden="0"
                                    data-required="0"
                                    data-id="${id}"
                                    class="form-control propsControl activeField fieldItem"
                                    multiple
                                    disabled
                                >
                                <option selected disabled> -- Select an option -- </option>
                                </select>
                            </div>`;
                break;
            case 'radio':
                content += `<div class="col-9 propsControl activeField">
                             <label class="multioptionslabel">${label}</label>
                             <span class="multipicklist_data" data-lblname="${label}" data-fieldname="${name}"></span>
                             <input
                                 type="radio"
                                 class="custom-control-input fieldItem"
                                 data-type="${type}"
                                 data-field="${field}"
                                 data-label="${label}"
                                 data-name="${name}"
                                 data-hint="${label}"
                                 data-order="${order}"
                                 data-default=""
                                 data-value=""
                                 data-values="${values}"
                                 data-hidden="0"
                                 data-id="${id}"
                                 disabled>
                             <div>`;
                if (typeof options == 'undefined') {
                    content += `<div class="custom-control custom-checkbox first-radio">
                                     <input
                                         type="hidden"
                                         data-value="yes"
                                         class="custom-control-input"
                                         disabled>
                                    <label class="custom-control-label">Yes</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input
                                        type="hidden"
                                        data-value="no"
                                        class="custom-control-input"
                                        disabled>
                                    <label class="custom-control-label">No</label>
                                </div>`;
                } else {
                    $.each(options, function () {
                        content += `<div class="custom-control custom-checkbox first-radio">
                                        <input
                                            type="hidden"
                                            data-value="${this}"
                                            class="custom-control-input"
                                            disabled> 
                                       <label class="custom-control-label">${this}</label>
                                   </div>`;
                    });
                }
                content += `</div>
                </div>`;
                break;

            case 'multiline':
                content += `<div class="col-9">
                                <label>${label}</label>
                                <textarea
                                    data-field="${field}"
                                    data-type="${type}"
                                    data-label="${label}"
                                    data-name="${name}"
                                    data-hint=""
                                    data-order="${order}"
                                    data-hidden="0"
                                    data-required="0"
                                    class="form-control propsControl activeField fieldItem"
                                    placeholder="Untitled"
                                    disabled
                                ></textarea>
                            </div>`;
                break;

            case 'multiselect':

                content += `<div class="col-9 propsControl activeField">
                                <label class="multioptionslabel">${label}</label>
                                <span class="multipicklist_data" data-lblname="${label}" data-fieldname="${name}"></span>
                                <input
                                   type="checkbox"
                                   data-field="${field}"
                                   data-type="multiselect"
                                   data-label="${label}"
                                   data-olabel=""
                                   data-hint="${label}"
                                   data-name="${name}"
                                   data-order="${order}"
                                   data-value="Option 1"
                                   data-values="${values}"
                                   data-hidden="0"
                                   data-required="0"
                                   data-id="${id}"
                                   class="custom-control-input fieldItem"
                                   disabled> 
                                <div>`;

                if (typeof options == 'undefined') {
                    content += `<div class="custom-control custom-checkbox">
                                    <input
                                    type="hidden"
                                    data-value="Option 1"
                                    class="custom-control-input"
                                    disabled>
                                    <label class="custom-control-label">Option 1</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input
                                    type="hidden"
                                    data-value="Option 2"
                                    class="custom-control-input"
                                    disabled>
                                    <label class="custom-control-label">Option 2</label>
                                </div>`;
                } else {
                    $.each(options, function () {
                        content += `<div class="custom-control custom-checkbox">
                                        <input
                                        type="hidden"
                                        data-value="${this}"
                                        class="custom-control-input"
                                        disabled>
                                        <label class="custom-control-label">${this}</label>
                                    </div>`;
                    });
                }
                content += `</div>
                            </div>`;
                break;

            case 'checkbox':

                content += `<div class="col-9 check-or-not">
                                <label class="custom-control-label">Untitled</label>
                                    <input
                                        type="checkbox"
                                        class="custom-control-input propsControl activeField fieldItem"
                                        data-type="${type}"
                                        data-field="${field}"
                                        data-label="Untitled"
                                        data-name="${name}"
                                        data-order="${order}"
                                        data-default=""
                                        data-values="${values}"
                                        data-hidden="0"
                                        disabled>
                            </div>`;

                break;

            case 'relationship' :
                content += `<div class="col-9">
                                <label>${label}</label>
                                <input
                                    type="${type}"
                                    class="form-control propsControl activeField fieldItem"
                                    placeholder=""
                                    data-field="${field}"
                                    data-type="${type}"
                                    data-label="${label}"
                                    data-name="${name}"
                                    data-hint=""
                                    data-order="${order}"
                                    data-hidden="0"
                                    data-unique="0"
                                    data-required="0"
                                    data-related-type="lookup"
                                    data-related="0"
                                    data-relid=""
                                    data-primary-column=""
                                    data-relfields=""
                                    disabled>
                            </div>`;
                break;
            case 'date':
                content += `<div class="col-9">
                                <label>${label}</label>
                                <input
                                    type="text"
                                    class="form-control propsControl activeField fieldItem"
                                    placeholder="Untitled"
                                    data-field="${field}"
                                    data-type="${type}"
                                    data-label="${label}"
                                    data-name="${name}"
                                    data-hint=""
                                    data-order="${order}"
                                    data-hidden="0"
                                    data-unique="0"
                                    data-required="0"
                                    data-hind=""
                                    disabled>
                            </div>`;
                break;
            default:
                content += `<div class="col-9">
                                <label>${label}</label>
                                <input
                                    type="${type}"
                                    class="form-control propsControl activeField fieldItem"
                                    placeholder="Untitled"
                                    data-field="${field}"
                                    data-type="${type}"
                                    data-label="${label}"
                                    data-name="${name}"
                                    data-hint=""
                                    data-editable="1"
                                    data-order="${order}"
                                    data-hidden="0"
                                    data-unique="0"
                                    data-required="0"
                                    disabled>
                            </div>`;
        }

        content += ` <div class="col-3 field-controllers">

                        <a href="#" class="orderField">
                            <i class="fas fa-arrows-alt mr-3"></i>
                        </a>

                        <a href="#" class="deleteField">
                            <i class="fas fa-trash"></i>
                        </a>

                    </div>
                </div>
            </div>

        `;

        return content;

    },

    // Properties content of the new created section
    newSectionProperties() {

        let content = '';

        content += `<div class="col-12">
                        <div class="pt-2 pb-2">
                                <label>${translation.interface_name}</label> 
                                <input
                                    type="text"
                                    class="form-control sectionLabel"
                                    placeholder="Enter Section label">
                            </div>
                            <div class="pt-2 pb-2">
                                <label>${translation.section_name}</label>
                                <input
                                    type="text"
                                    class="form-control sectionName"
                                    placeholder="Enter Section Name">
                            </div>

                            <div class="pt-2 pb-2">
                                <span class="cu-font-sm cu-font-light">
                                    ${translation.to_hide_a_section}
                                </span>
                            </div>
                        </div>
                    `;

        return content;

    },

    newRelatedSectionProperties(tables, fiters = '') {

        let content = '';

        content += `<div class="col-12">
                        <span>${translation.section}</span>
                            <div class="pt-2 pb-2">
                                <label>${translation.interface_name}</label> 
                                <input
                                    type="text"
                                    class="form-control sectionLabel"
                                    placeholder="Enter Section Label"
                                    data-type="related-section">
                            </div>
                            <div class="pt-2 pb-2">
                                <label>${translation.section_name}</label>
                                <input
                                    type="text"
                                    class="form-control sectionName"
                                    placeholder="Enter Section Name">
                            </div>
                            
                            <div class="pt-2 pb-1">
                                <span class="cu-font-sm cu-font-light">
                                    <div class="form-group form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input sectionEdit"
                                            checked
                                        >
                                        <label class="form-check-label" for="isReq">${translation.do_not_open_record_from_linked_section}</label>
                                    </div>      
                                </span>
                            </div>

                            <div class="pt-2 pb-1">
                                <span class="cu-font-sm cu-font-light">
                                    <div class="form-group form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input sectionDisableLink"
                                            checked
                                        >
                                        <label class="form-check-label" for="isReq">${translation.disable_opening_related_records}</label>
                                    </div>      
                                </span>
                            </div>

                            <div class="pt-2 pb-1">
                                <span class="cu-font-sm cu-font-light">
                                    <div class="form-group form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input toggleSectionCounter"
                                            checked
                                        >
                                        <label class="form-check-label" for="toggleSectionCounter">${translation.enable_counter}</label>
                                    </div>      
                                </span>
                            </div>

                            <div class="pt-1 pb-2">
                                <span class="cu-font-sm cu-font-light">
                                    <div class="form-group form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input allowScroll"
                                        >
                                        <label class="form-check-label" for="allowScroll">${translation.enable_infinite_scroll}</label>
                                    </div>      
                                </span>
                            </div>
                            
                            <div class="pt-1 pb-2">
                                <span class="cu-font-sm cu-font-light">
                                    <div class="form-group form-check">
                                        <input
                                            type="checkbox"
                                            class="form-check-input fullText"
                                        >
                                        <label class="form-check-label" for="fullText">Show Full Content</label>
                                    </div>      
                                </span>
                            </div>
                            
                           <div class="pt-2 pb-2">
                                <label>${translation.show_no_of_records}</label>
                                <input
                                    type="number"
                                    min="1"
                                    max="100"
                                    value="10"
                                    class="form-control section-no-of-records"
                                    placeholder="No. of recirds">
                            </div>
                            
                           <div class="pt-2 pb-2">
                                <label>${translation.related_to}</label>
                                <select
                                    class="form-control related-table"
                                    data-field="related-to">
                                    <option disabled selected></option>
                                    ${tables}
                                </select>
                                
                                <label>${translation.filter}</label>
                                <select
                                    class="form-control related-table-filter"
                                    data-field="related-filter">
                                    <option value="">${translation.select_filter}</option>
                                    ${fiters}
                                </select>
                                
                                <div class="pt-2 pb-2 primary-key-holder">
                                    <div class="text-center">
                                        <label class="btn-link add-fetch-keys" style="cursor: pointer;">Add Primary Keys</a>
                                    </div>
                                    
                                    <div class="primary-key">
                                    
                                    </div>
                                </div>
                                
<!--                                <div class="pt-2 pb-2 save-keys-holder">-->
<!--                                    <div class="text-center">-->
<!--                                        <label class="btn-link add-save-keys" style="cursor: pointer;">Add Save Keys</a>-->
<!--                                    </div>-->
<!--                                    -->
<!--                                    <div class="save-keys">-->
<!--                                    -->
<!--                                    </div>-->
<!--                                </div>-->
                                
                                <div class="fields-order mb-2">
                                    <div class="mt-2">${translation.visible_fields}: </div>
                                        
                                    <div class="visible-fields field_container field_short connectedSortable d-block"></div>
                                    
                                    <div class="mb-2">${translation.hidden_fields}:</div>
                                    <div class="hidden-fields field_container hidden_field_short connectedSortable d-block"></div>
                                </div>
                            </div>
                        </div>
                    `;

        return content;

    },

}
